<main class="forgot-password-confirm-page">
  <div class="content-wrapper">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
</main>
